import React from 'react';
import PremiumQuiz from '../components/PremiumQuiz';

const QUESTIONS = [
  { id: 1, text: "Você já tentou parar de usar alguma substância ou comportamento compulsivo e não conseguiu?", options: [
    { label: "Nunca tentei", value: 0 }, { label: "Sim, uma vez", value: 1 }, { label: "Sim, várias vezes", value: 2 }, { label: "Sim, constantemente", value: 3 },
  ]},
  { id: 2, text: "Você sente que precisa de quantidades cada vez maiores para obter o mesmo efeito?", options: [
    { label: "Não", value: 0 }, { label: "Às vezes", value: 1 }, { label: "Frequentemente", value: 2 }, { label: "Sempre", value: 3 },
  ]},
  { id: 3, text: "O uso de substâncias ou comportamentos compulsivos já afetou seus relacionamentos?", options: [
    { label: "Não afetou", value: 0 }, { label: "Um pouco", value: 1 }, { label: "Bastante", value: 2 }, { label: "Destruiu relacionamentos", value: 3 },
  ]},
  { id: 4, text: "Você já fez coisas que se arrependeu por causa do uso?", options: [
    { label: "Nunca", value: 0 }, { label: "Raramente", value: 1 }, { label: "Várias vezes", value: 2 }, { label: "Constantemente", value: 3 },
  ]},
  { id: 5, text: "Você sente ansiedade, irritabilidade ou desconforto quando tenta ficar sem usar?", options: [
    { label: "Não sinto nada", value: 0 }, { label: "Um pouco desconfortável", value: 1 }, { label: "Bastante ansioso", value: 2 }, { label: "Insuportável", value: 3 },
  ]},
  { id: 6, text: "Você já escondeu o quanto usa de pessoas próximas?", options: [
    { label: "Nunca", value: 0 }, { label: "Às vezes", value: 1 }, { label: "Frequentemente", value: 2 }, { label: "Sempre", value: 3 },
  ]},
  { id: 7, text: "O uso já prejudicou sua vida profissional ou financeira?", options: [
    { label: "Não", value: 0 }, { label: "Um pouco", value: 1 }, { label: "Significativamente", value: 2 }, { label: "Muito gravemente", value: 3 },
  ]},
  { id: 8, text: "Você sente que perdeu o controle sobre o uso?", options: [
    { label: "Tenho controle total", value: 0 }, { label: "Às vezes perco o controle", value: 1 }, { label: "Frequentemente sem controle", value: 2 }, { label: "Completamente sem controle", value: 3 },
  ]},
  { id: 9, text: "Você já pensou em buscar ajuda profissional?", options: [
    { label: "Nunca pensei", value: 0 }, { label: "Já pensei mas não busquei", value: 1 }, { label: "Já busquei uma vez", value: 2 }, { label: "Já busquei várias vezes", value: 3 },
  ]},
  { id: 10, text: "Você acredita que pode mudar sua situação?", options: [
    { label: "Não preciso mudar", value: 0 }, { label: "Quero mudar mas não sei como", value: 1 }, { label: "Estou disposto a mudar", value: 2 }, { label: "Estou desesperado para mudar", value: 3 },
  ]},
];

const CONFIG = {
  role: 'paciente',
  icon: 'Brain',
  accentColor: '#6366f1',
  accentColorAlt: '#818cf8',
  welcomeTitle: 'Descubra seu nível atual',
  welcomeSubtitle: 'Entenda o que está acontecendo com você e como podemos ajudar na sua jornada',
  ctaText: 'Começar Minha Recuperação',
  disclaimer: 'Este quiz é informativo e não substitui avaliação profissional.',
};

function getResult(score) {
  if (score <= 8) return {
    level: 'leve', iconName: 'ShieldCheck', neonColor: '#22c55e',
    title: 'Risco Leve',
    headline: 'Você está no caminho certo',
    message: 'Seus resultados indicam um nível leve. A U-Clean pode ajudar você com ferramentas de prevenção, autoconhecimento e apoio comunitário para manter esse equilíbrio.',
  };
  if (score <= 18) return {
    level: 'moderado', iconName: 'AlertTriangle', neonColor: '#f59e0b',
    title: 'Risco Moderado',
    headline: 'Existe um padrão que precisa de atenção',
    message: 'Seus resultados indicam sinais de alerta. A U-Clean oferece programas estruturados de 30, 60 e 90 dias que podem ajudar você nessa jornada de recuperação.',
  };
  return {
    level: 'alto', iconName: 'Heart', neonColor: '#ef4444',
    title: 'Atenção: Busque Apoio',
    headline: 'Você não precisa passar por isso sozinho',
    message: 'Seus resultados sugerem que você pode se beneficiar muito de apoio profissional. A U-Clean conecta você com profissionais certificados e uma comunidade acolhedora.',
  };
}

export default function QuizRecuperacao() {
  return <PremiumQuiz questions={QUESTIONS} config={CONFIG} getResult={getResult} />;
}
